import React from "react";
import { FaFacebookF, FaGithub, FaInstagram, FaLinkedinIn } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer
      className="pt-5 pb-3 px-4 text-white mt-5"
      style={{ backgroundColor: "#5A7D9A" }}
    >
      <div className="container">
        <div className="row gy-4">
          {/* About */}
          <div className="col-md-4">
            <p>
              At Vizionexl, we empower businesses with end-to-end technology solutions —
              Whether you're a startup or an enterprise, we provide scalable, secure, and
              high-performing digital products tailored to your goals.
            </p>
            <p>
              Our team of expert developers, ethical hackers, marketers, and trainers
              ensure every project is future-ready and result-driven.
            </p>
          </div>

          {/* Contact Details */}
          <div className="col-md-3">
            <h5 className="text-warning">Contact Details</h5>
            <p className="mb-1">📧 vizionexlpvtltd@gmail.com</p>
            <p className="mb-1">🌐 www.vizionexltechnologies.in</p>
            <p className="mb-1">
              📍 Opp Hanamashetty Tyres Shop,<br />
              Gurukul Road, Vijayapura – 586101,<br />
              Karnataka, India
            </p>
            <p className="mb-1">
              <a
                href="https://maps.app.goo.gl/cnBTexA498SSvic5A"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-decoration-underline"
              >
                View on Google Maps
              </a>
            </p>
            <p>📞 +91 6362789427</p>
          </div>

          {/* Information Links */}
          <div className="col-md-2">
            <h5 className="text-warning">Information</h5>
            <ul className="list-unstyled">
              <li><a href="#" className="text-white text-decoration-none">Home</a></li>
              <li><a href="/about" className="text-white text-decoration-none">Who are we</a></li>
              <li><a href="/what-we-do" className="text-white text-decoration-none">What we do</a></li>
              <li><a href="/projects" className="text-white text-decoration-none">Our Projects</a></li>
              <li><a href="/consult" className="text-white text-decoration-none">Consult Us</a></li>
              <li><a href="/careers" className="text-white text-decoration-none">Career</a></li>
            </ul>
          </div>

          {/* Social Buttons */}
          <div className="col-md-3">
            <h5 className="text-warning mb-3">Social</h5>
            <div className="d-flex flex-column">
              <a
                href="https://www.linkedin.com/company/vizionexl/"
                className="btn btn-outline-light btn-sm mb-2 d-flex align-items-center"
                style={{ width: "140px" }}
              >
                <FaLinkedinIn className="me-2" /> LinkedIn
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61576292647187"
                className="btn btn-outline-light btn-sm mb-2 d-flex align-items-center"
                style={{ width: "140px" }}
              >
                <FaFacebookF className="me-2" /> Facebook
              </a>

              <a
                href="https://www.instagram.com/vizionexl_technologies?igsh=MTczMnlwZjV1amRvdg=="
                className="btn btn-outline-light btn-sm mb-2 d-flex align-items-center"
                style={{ width: "140px" }}
              >
                <FaInstagram className="me-2" /> Instagram
              </a>

              <a
                href="https://github.com/Vizionexl"
                className="btn btn-outline-light btn-sm d-flex align-items-center"
                style={{ width: "140px" }}
              >
                <FaGithub className="me-2" /> GitHub
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="text-center pt-4 mt-4 border-top border-light">
          <small className="d-block">
            All Rights Reserved. © 2025 Website designed and developed by{" "}
            <strong>Vizionexl</strong>.
          </small>
        </div>
      </div>
    </footer>
  );
}
